import React, { useEffect, useState } from 'react'
import { pricesApi } from '../services/api'
import { MarketPrices, MASKED_PRICE } from '../types'
import { formatToman, formatDateTimeFa } from '../utils/format'

/** نوار نمایش قیمت خام طلا و نقره (بر اساس قیمت جهانی) */
const PriceTicker: React.FC = () => {
  const [prices, setPrices] = useState<MarketPrices | null>(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const res = await pricesApi.getCurrent()
        if (res.data.success && res.data.data) setPrices(res.data.data)
      } catch {
        setError(true)
      }
    }
    load()
  }, [])

  const hidden = !!prices?.priceHidden || prices?.gold24KPerGram === null

  const tiles: Array<{ label: string; value: (p: MarketPrices) => string; color: string }> = [
    {
      label: 'طلای ۲۴ عیار (خام)',
      value: (p) => (p.gold24KPerGram === null ? MASKED_PRICE : formatToman(p.gold24KPerGram)),
      color: 'bg-gold-100 text-gold-800'
    },
    {
      label: 'طلای ۱۸ عیار (۷۵۰)',
      value: (p) => (p.gold18KPerGram === null ? MASKED_PRICE : formatToman(p.gold18KPerGram)),
      color: 'bg-gold-100 text-gold-800'
    },
    {
      label: 'نقره خام (۹۹۹)',
      value: (p) => (p.silverRawPerGram === null ? MASKED_PRICE : formatToman(p.silverRawPerGram)),
      color: 'bg-gray-100 text-gray-800'
    }
  ]

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className="relative flex h-2.5 w-2.5">
            <span
              className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
                hidden ? 'bg-red-400' : 'bg-green-400'
              }`}
            ></span>
            <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${hidden ? 'bg-red-500' : 'bg-green-500'}`}></span>
          </span>
          <h3 className="font-bold text-gray-800">قیمت خام لحظه‌ای</h3>
        </div>

        {/* کاشی‌های قیمت — در موبایل اسکرول افقی نرم */}
        <div className="flex items-center gap-4 overflow-x-auto scrollbar-hide -mx-1 px-1 sm:overflow-visible">
          {!prices && !error && (
            <span className="text-xs text-gray-400 animate-pulse">در حال دریافت قیمت…</span>
          )}
          {error && (
            <span className="text-xs text-red-500">دریافت قیمت فعلاً ممکن نیست؛ از پنل ادمین حالت دستی تنظیم کنید</span>
          )}
          {!error && prices && (
            <>
              {tiles.map((tile) => (
                <div key={tile.label} className="text-center leading-tight shrink-0">
                  <div className={`text-[11px] px-2 py-0.5 rounded-full ${tile.color}`}>{tile.label}</div>
                  <div className="text-sm font-bold text-gray-900 mt-0.5 whitespace-nowrap">{tile.value(prices)}</div>
                </div>
              ))}
            </>
          )}
        </div>

        {prices && (
          <span className="text-[11px] text-gray-400">
            {hidden ? (
              <span className="text-red-500 font-bold">قیمت‌ها موقتاً توسط مدیر پنهان شده است</span>
            ) : (
              <>منبع: {prices.source} — {formatDateTimeFa(prices.updatedAt || '')}</>
            )}
          </span>
        )}
      </div>
    </div>
  )
}

export default PriceTicker
